import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AdminPanel.css';

const AdminPanel = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingProperty, setEditingProperty] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    type: 'buy',
    price: '',
    city: '',
    area: '',
    rooms: '',
    bathrooms: '',
    address: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    features: '',
    status: 'active'
  });
  const [images, setImages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Check authentication
    if (!localStorage.getItem('adminAuthenticated')) {
      navigate('/admin');
      return;
    }
    fetchProperties();
  }, [navigate]);

  const fetchProperties = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/properties');
      setProperties(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching properties:', error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    setImages(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      Object.keys(formData).forEach(key => {
        if (formData[key] !== '') {
          form.append(key, formData[key]);
        }
      });
      
      images.forEach((image) => {
        form.append('images', image);
      });

      if (editingProperty) {
        await axios.put(`/api/properties/${editingProperty.id}`, form, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        await axios.post('/api/properties', form, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }

      resetForm();
      fetchProperties();
      alert(editingProperty ? 'تم تحديث العقار بنجاح' : 'تم إضافة العقار بنجاح');
    } catch (error) {
      console.error('Error saving property:', error);
      alert('حدث خطأ أثناء حفظ العقار');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      description: '',
      category: '',
      type: 'buy',
      price: '',
      city: '',
      area: '',
      rooms: '',
      bathrooms: '',
      address: '',
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      features: '',
      status: 'active'
    });
    setImages([]);
    setEditingProperty(null);
    setShowForm(false);
  };

  const handleEdit = (property) => {
    setEditingProperty(property);
    setFormData({
      title: property.title,
      description: property.description || '',
      category: property.category,
      type: property.type,
      price: property.price.toString(),
      city: property.city,
      area: property.area ? property.area.toString() : '',
      rooms: property.rooms ? property.rooms.toString() : '',
      bathrooms: property.bathrooms ? property.bathrooms.toString() : '',
      address: property.address || '',
      contactName: property.contactName || '',
      contactPhone: property.contactPhone || '',
      contactEmail: property.contactEmail || '',
      features: property.features ? property.features.join(', ') : '',
      status: property.status || 'active'
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا العقار؟')) {
      try {
        await axios.delete(`/api/properties/${id}`);
        fetchProperties();
        alert('تم حذف العقار بنجاح');
      } catch (error) {
        console.error('Error deleting property:', error);
        alert('حدث خطأ أثناء حذف العقار');
      }
    }
  };

  const handleDeleteImage = async (propertyId, imageIndex) => {
    if (window.confirm('هل تريد حذف هذه الصورة؟')) {
      try {
        await axios.delete(`/api/properties/${propertyId}/images/${imageIndex}`);
        fetchProperties();
      } catch (error) {
        console.error('Error deleting image:', error);
        alert('حدث خطأ أثناء حذف الصورة');
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminAuthenticated');
    navigate('/admin');
  };

  if (loading) {
    return (
      <div className="admin-panel">
        <div className="loading">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="container">
        <div className="admin-header">
          <h1>لوحة التحكم - إدارة العقارات</h1>
          <div className="admin-actions">
            <button onClick={() => setShowForm(true)} className="btn btn-primary">
              + إضافة عقار جديد
            </button>
            <button onClick={handleLogout} className="btn btn-secondary">
              تسجيل الخروج
            </button>
          </div>
        </div>

        {showForm && (
          <div className="property-form-modal">
            <div className="form-modal-content">
              <div className="form-header">
                <h2>{editingProperty ? 'تعديل عقار' : 'إضافة عقار جديد'}</h2>
                <button onClick={resetForm} className="close-btn">×</button>
              </div>
              <form onSubmit={handleSubmit} className="property-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>عنوان العقار *</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>نوع الإعلان *</label>
                    <select
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="buy">للبيع</option>
                      <option value="rent">للإيجار</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>نوع العقار *</label>
                    <select
                      name="category"
                      value={formData.category}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">اختر نوع العقار</option>
                      <option value="شقة">شقة</option>
                      <option value="منزل">منزل</option>
                      <option value="أرض">أرض</option>
                      <option value="مكتب">مكتب</option>
                      <option value="متجر">متجر</option>
                      <option value="مستودع">مستودع</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>المدينة *</label>
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">اختر المدينة</option>
                      <option value="دمشق">دمشق</option>
                      <option value="حلب">حلب</option>
                      <option value="حمص">حمص</option>
                      <option value="حماة">حماة</option>
                      <option value="اللاذقية">اللاذقية</option>
                      <option value="طرطوس">طرطوس</option>
                      <option value="دير الزور">دير الزور</option>
                      <option value="الحسكة">الحسكة</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>السعر (ل.س) *</label>
                    <input
                      type="number"
                      name="price"
                      value={formData.price}
                      onChange={handleInputChange}
                      required
                      min="0"
                    />
                  </div>
                  <div className="form-group">
                    <label>المساحة (م²)</label>
                    <input
                      type="number"
                      name="area"
                      value={formData.area}
                      onChange={handleInputChange}
                      min="0"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>عدد الغرف</label>
                    <input
                      type="number"
                      name="rooms"
                      value={formData.rooms}
                      onChange={handleInputChange}
                      min="0"
                    />
                  </div>
                  <div className="form-group">
                    <label>عدد الحمامات</label>
                    <input
                      type="number"
                      name="bathrooms"
                      value={formData.bathrooms}
                      onChange={handleInputChange}
                      min="0"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>العنوان</label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label>الوصف *</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                    rows="4"
                  />
                </div>

                <div className="form-group">
                  <label>المميزات (مفصولة بفواصل)</label>
                  <input
                    type="text"
                    name="features"
                    value={formData.features}
                    onChange={handleInputChange}
                    placeholder="مثال: حديقة, موقف سيارات, مصعد"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>اسم جهة الاتصال</label>
                    <input
                      type="text"
                      name="contactName"
                      value={formData.contactName}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>رقم الهاتف</label>
                    <input
                      type="tel"
                      name="contactPhone"
                      value={formData.contactPhone}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>البريد الإلكتروني</label>
                  <input
                    type="email"
                    name="contactEmail"
                    value={formData.contactEmail}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label>{editingProperty ? 'إضافة صور جديدة' : 'الصور *'}</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    required={!editingProperty}
                  />
                  <small>يمكنك اختيار عدة صور (JPEG, PNG, GIF, WEBP)</small>
                </div>

                {editingProperty && editingProperty.images && editingProperty.images.length > 0 && (
                  <div className="existing-images">
                    <label>الصور الحالية:</label>
                    <div className="images-grid">
                      {editingProperty.images.map((image, index) => (
                        <div key={index} className="image-preview">
                          <img src={`/api${image}`} alt={`Property ${index + 1}`} />
                          <button
                            type="button"
                            onClick={() => handleDeleteImage(editingProperty.id, index)}
                            className="delete-image-btn"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="form-group">
                  <label>الحالة</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                  >
                    <option value="active">نشط</option>
                    <option value="inactive">غير نشط</option>
                  </select>
                </div>

                <div className="form-actions">
                  <button type="submit" className="btn btn-primary">
                    {editingProperty ? 'تحديث' : 'إضافة'}
                  </button>
                  <button type="button" onClick={resetForm} className="btn btn-secondary">
                    إلغاء
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div className="properties-table-container">
          <h2>قائمة العقارات ({properties.length})</h2>
          {properties.length > 0 ? (
            <div className="properties-table">
              <table>
                <thead>
                  <tr>
                    <th>الصورة</th>
                    <th>العنوان</th>
                    <th>النوع</th>
                    <th>المدينة</th>
                    <th>السعر</th>
                    <th>الحالة</th>
                    <th>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {properties.map((property) => (
                    <tr key={property.id}>
                      <td>
                        {property.images && property.images.length > 0 ? (
                          <img
                            src={`/api${property.images[0]}`}
                            alt={property.title}
                            className="property-thumbnail"
                          />
                        ) : (
                          <div className="no-thumbnail">-</div>
                        )}
                      </td>
                      <td>{property.title}</td>
                      <td>
                        <span className={`type-badge ${property.type}`}>
                          {property.type === 'buy' ? 'للبيع' : 'للإيجار'}
                        </span>
                      </td>
                      <td>{property.city}</td>
                      <td>{property.price.toLocaleString()} ل.س</td>
                      <td>
                        <span className={`status-badge ${property.status}`}>
                          {property.status === 'active' ? 'نشط' : 'غير نشط'}
                        </span>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button
                            onClick={() => handleEdit(property)}
                            className="btn-edit"
                          >
                            تعديل
                          </button>
                          <button
                            onClick={() => handleDelete(property.id)}
                            className="btn-delete"
                          >
                            حذف
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-state">
              <h3>لا توجد عقارات</h3>
              <p>ابدأ بإضافة عقار جديد</p>
              <button onClick={() => setShowForm(true)} className="btn btn-primary">
                إضافة عقار جديد
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;

